// extracted by mini-css-extract-plugin
export var container = "_6p-0";
export var error = "_6p-9";
export var label = "_6p-5";
export var light = "_6p-6";
export var md = "_6p-3";
export var sm = "_6p-2";
export var thin = "_6p-8";
export var thinBold = "_6p-7";
export var vertical = "_6p-4";
export var xs = "_6p-1";